<template>
  <div class="row">
    <div class="col-12 col-lg-6 c g">
        <div class="card card-body">
            <div class="card card-body border" style="overflow-y: scroll; height: 200px; padding: 5px">
                <input type="text" class="form-control form-control-sm" placeholder="ابحث هنا..." @change="gg()" @keyup="gg()" v-model="s" name="" id="">
                <template v-for="u in users">
                    <div class="form-check" v-if="u.name.includes(s) || u.phone.includes(s)" :key="u._id">
                        <label class="form-check-label">
                        <input type="radio" class="form-check-input" :value="u._id" v-model="selected_user">
                        {{ u.name }}
                    </label>
                    </div>
                </template>
            </div>
            <div class="form-group">
              <label for="">المطلوب نقله</label>
              <select class="form-control" v-model="selected_model">
                <option value="">-- اختر --</option>
                <option v-for="m in models" :key="m" :value="m">{{ m }}</option>
              </select>
            </div>
            <div class="col-12 text-center g">
                <button class="btn btn-primary" @click="move()" v-if="!loadingx">نقل الآن</button>
                <button class="btn btn-outline-danger" v-if="loadingx">جاري النقل...</button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            jwt: localStorage.getItem('jwt'),
            users: [],
            q: "",
            page: 0,
            s: "",
            models: [],
            selected_model: "",
            selected_user: "",
            loadingx: false
        }
    },
    created(){
        var g = this;
        g.gg()
        $.post(api + '/admin/users/models', {
            jwt: this.jwt
        }).then(function(r){
            g.loading = false
            if(r.status != 100){
                alert(r.response)
            }else{
                g.models = r.response
            }
        }).fail(function(){
            g.loading = false;
        })
    },
    methods: {
        gg(){
            var g = this;
            $.post(api + '/admin/users/list', {
                jwt: this.jwt,
                q: g.s,
                page: this.page,
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response)
                }else{
                    g.users = r.response
                }
            }).fail(function(){
                g.loading = false;
            })
        },
        move(){
            var g = this;
            g.loadingx = true;
            $.post(api + '/admin/users/move-from-old', {
                jwt: this.jwt,
                user_id: g.selected_user,
                model: g.selected_model
            }).then(function(r){
                g.loading = false
                g.loadingx = false;
                if(r.status != 100){
                    alert(r.response)
                }else{
                    alert(r.response, 100)
                }
            }).fail(function(){
                g.loadingx = false;
                g.loading = false;
            })
        }
    }
}
</script>

<style>

</style>